import { CIcon } from '~/icons/types'

export const ciComments: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M20.801 18.238a4.81 4.81 0 0 0 1.699-3.564c0-1.781-1.104-3.356-2.788-4.32.019-.192.039-.384.039-.58 0-4.01-4.094-7.272-9.125-7.272S1.5 5.763 1.5 9.784c.042 1.921.924 3.704 2.436 4.95l-1.644 3.749a.499.499 0 0 0 .697.64l4.598-2.497c.767.216 1.558.349 2.355.397 1.084 1.75 3.333 2.959 5.932 2.959a8.13 8.13 0 0 0 2.141-.287l3.215 1.746a.498.498 0 0 0 .576-.071.499.499 0 0 0 .12-.569l-1.125-2.563ZM7.674 15.61a.505.505 0 0 0-.384.039l-3.497 1.899 1.214-2.769a.5.5 0 0 0-.163-.604C3.393 13.11 2.537 11.501 2.5 9.773 2.5 6.315 6.145 3.5 10.625 3.5s8.125 2.814 8.125 6.272c0 .041-.007.08-.008.122a7.939 7.939 0 0 0-2.869-.531c-3.653 0-6.625 2.382-6.625 5.31 0 .445.076.875.205 1.288-.602-.07-1.2-.176-1.779-.352Zm12.056 2.678.692 1.578-2.111-1.146a.496.496 0 0 0-.383-.04 7.095 7.095 0 0 1-2.055.303c-3.102 0-5.625-1.934-5.625-4.31 0-2.376 2.524-4.31 5.625-4.31 3.103 0 5.626 1.934 5.626 4.299-.025 1.189-.61 2.291-1.607 3.021a.504.504 0 0 0-.162.605Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'comments',
  type: 'thin'
}
